import React from 'react'
import { Table, Tag, Space, Skeleton } from 'antd'
import { RobotOutlined } from '@ant-design/icons'
import Title from '../../system/title/Title'
import useSWR from 'swr';
import ApiManager from '../../../business/services/ApiManager';
import { toDate } from '../../../helpers/dateFormatHelper';
import Loader from '../../system/loader/Loader';
import Section from '../section/Section';

const PaymentList = () => {
    const { data, error } = useSWR(['payments'], (_key) => ApiManager.customers.getPayments())
    
    const columns = [
        {
            title: 'Montant',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount: number) => (
                <Space size="small">
                    {amount/100} €
                </Space>
            )
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (id: React.ReactNode) => (
                <Space size="small">
                     {id}
                </Space>
            )
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (date: string) => (
                <Space size="small">
                     {toDate(date)}
                </Space>
            )
        },
        
    ]

    if (error) return <div>failed to load</div>
    if (!data) return <Skeleton active />

    return (
        <Section title="Paiements">
            <Table columns={columns} dataSource={data.data} />
        </Section>
    )
}

export default PaymentList
